var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"previous__btn",on:{"click":_vm.clickHandler}},[_vm._v("\n  "+_vm._s(_vm.$t('general.back'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }